export const ORDER_STATUS_MESSAGES = {
  new_order: 'Your order has been placed',
  confirmed: 'Your order has been confirmed',
  processing: 'Your order is being prepared',
  packed: 'Your order has been packed',
  shipped: 'Your order has been shipped',
  out_for_delivery: 'Your order is out for delivery',
  delivered: 'Your order has been delivered',
  ready_for_pickup: 'Your order is ready for pickup at our store',
  cancelled: 'Your order has been cancelled',
  returned: 'Your return has been processed',
  refunded: 'Your refund has been initiated',
  pending: 'Your order is waiting for payment',
  cod_pending: 'Your order has been placed with cash on delivery',
  pay_at_store_pending: 'Your order will be paid during pickup',
  payment_pending: 'Your order is waiting for payment',
  order_received: 'Your order has been placed',
  payment_confirmed: 'Your payment has been confirmed',
  ready_for_shipment: 'Your order is ready to ship',
  picked_up: 'Your order has been picked up',
}

export const getOrderStatusMessage = (status, fallback) => {
  const key = (status || '').toLowerCase()
  return ORDER_STATUS_MESSAGES[key] || fallback || `Your order status: ${key.replace(/_/g, ' ')}`
}

export const formatNotification = (notif) => {
  if (notif.type === 'support_reply') {
    return {
      ...notif,
      title: notif.title || 'You have a new support reply',
      message: notif.message || notif.order_number || '',
    }
  }

  return {
    ...notif,
    title: notif.title || getOrderStatusMessage(notif.status, notif.message),
    message: notif.order_number ? `Order #${notif.order_number}` : (notif.message || ''),
  }
}
